module.exports = __webpack_public_path__ + "img/sand-bag-carry.b51cebba.jpg";